import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.SET_MY_PAYMENT_OUTSTANDING_ORDER:
      return { ...action.myOutstandingOrder };
    case Action.ADD_MY_PAYMENT_OUTSTANDING_ORDER:
      return { ...state, [action.data.proformaNo]: action.data };
    default: return state;
  }
};
